export default __webpack_public_path__ + "static/media/linkedin.2c779931.jpg";